export { default, MobileSearchBox } from './MobileSearchBox';



// WEBPACK FOOTER //
// ./app/components/search/MobileSearchBox/index.js